var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHexIconViolet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 35,
    viewBox: "0 0 33 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0L32.5215 8.73186V26.1956L16.5 34.9274L0.478531 26.1956V8.73186L16.5 0Z",
    fill: "#BCA8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexIconViolet);
export default __webpack_public_path__ + "static/media/hexIconViolet.8fabc270e4ecb57c0a2c84660c0e955b.svg";
export { ForwardRef as ReactComponent };